import { useCallback, useEffect, useState } from 'react';
import { TAxiosResponse } from '../../api/base/baseApiTypes';
import { AxiosResponse } from 'axios';
import {
  FAILURE_STATUS,
  IDLE_STATUS,
  LOADING_STATUS,
  LoadingType,
  SUCCESS_STATUS,
} from '../types/statuses';

type TUseFetchReturn = [
  {
    response: any;
    isLoading: boolean;
    error: any;
    detailedStatus: LoadingType;
  },
  (params?: any) => void,
];

type TApiMethod<T, U = any> = (param: U) => TAxiosResponse<T>;

export function useFetch<T, U = any>(
  apiMethod: TApiMethod<T, U>,
): TUseFetchReturn {
  const [response, setResponse] = useState<AxiosResponse<T> | null>(null);
  const [isLoading, setLoadingStatus] = useState(false);
  const [detailedStatus, setDetailedStatus] =
    useState<LoadingType>(IDLE_STATUS);
  const [error, setError] = useState(null);
  const [params, setParams] = useState<any>(null);

  const doFetch = useCallback((reqParams) => {
    setParams(reqParams);
    setLoadingStatus(true);
    
    // if(reqParams?.input === ""){
    //   setLoadingStatus(false);
    // }    
  }, []);

  useEffect(() => {
    if (!isLoading) return;
    let skipGetResponseAfterDestroy = false;
    setError(null);
    setDetailedStatus(LOADING_STATUS);
    apiMethod(params)
      .then((res) => {
        if (!skipGetResponseAfterDestroy) {
          setLoadingStatus(false);
          setDetailedStatus(SUCCESS_STATUS);
          setResponse(res);
        }
      })
      .catch((err: any) => {
        if (!skipGetResponseAfterDestroy) {
          setLoadingStatus(false);
          setDetailedStatus(FAILURE_STATUS);
          setError(err);
        }
      });

    // eslint-disable-next-line consistent-return
    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading, apiMethod, params, response]);

  return [{ response, isLoading, error, detailedStatus }, doFetch];
}
